import { Routes } from '@angular/router';
import { AdminGuard } from '@app/feature/admin';
import { ManagerGuard } from '@app/feature/manager/guards/manager.guard';
import { CustomerGuard } from '@core/guards/customer.guard';

export const routes: Routes = [
  {
    path: 'admin',
    canActivate: [AdminGuard],
    loadChildren: () =>
      import('@app/feature/admin/admin.route').then((m) => m.ADMIN_ROUTES),
    title: 'Administration',
  },
  {
    path: 'restaurants',
    canActivate: [CustomerGuard],
    loadChildren: () =>
      import('@app/feature/customer/customer.route').then((m) => m.routes),
    title: 'Restaurants',
  },

  {
    path: 'partnership',
    loadChildren: () =>
      import('@app/feature/customer/component/partner/partner.route').then(
        (m) => m.routes,
      ),
    title: 'Devenir Partenaire - Alienala',
  },
  // Pages légales
  {
    path: 'legal',
    loadChildren: () =>
      import('@app/feature/customer/component/legal/legal.route').then(
        (m) => m.routes,
      ),
    title: 'Legal',
  },

  // Pages informatives
  {
    path: 'info',
    loadChildren: () =>
      import('@app/feature/customer/component/info/info.route').then(
        (m) => m.routes,
      ),
    title: 'Info',
  },

  {
    path: 'authentication',
    loadChildren: () =>
      import('@app/feature/authentication/authentication.route').then(
        (m) => m.routes,
      ),
    title: 'Authentification',
  },
  {
    path: 'management/pending',
    loadComponent: () =>
      import(
        '@app/feature/authentication/component/pending-approval/pending-approval'
      ).then((m) => m.PendingApproval),
    title: 'Demande en attente - Alienala',
  },
  {
    path: 'management',
    canActivate: [ManagerGuard],
    loadChildren: () =>
      import('@app/feature/manager/manager.route').then((m) => m.routes),
    title: 'Gestion des restaurants',
  },
  {
    path: 'courier',
    loadChildren: () =>
      import('@app/feature/courier/courier.route').then(
        (m) => m.COURIER_ROUTES,
      ),
    title: 'Livraison',
  },
  {
    path: '',
    redirectTo: '/restaurants/home',
    pathMatch: 'full',
  },
  {
    path: 'error',
    title: 'Erreur',
    loadChildren: () =>
      import('@app/exception/exception.route').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: '/error/not-found',
    title: 'Page non trouvée',
  },
];
